import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=3f2a1a8a"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsImage: require('/opt/build/repo/components/Elements/Image.vue').default,ElementsLink: require('/opt/build/repo/components/Elements/Link.vue').default})
